import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isConfirmDeleteArtFolderPopupShownSelector, popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { resetLogosPaginationAction } from 'swag-client-common/redux/company-art-folder/company-art-folder.actions';
import { isCompanyOrdersAvailableSelector, userIdSelector } from '../../../redux/user/user.selectors';
import { deleteArtFolderLogo } from '../../../redux/company-art-folder/company-art-folder.actions';
import { DeleteArtFolderLogoPopupComponent } from './delete-art-folder-logo-popup';
const logoSelector = createSelector(popupParamsSelector, ({
  logo
}) => logo);
const logoIdSelector = createSelector(logoSelector, logo => logo === null || logo === void 0 ? void 0 : logo._id);
const showDeleteForCompanyFlowSelector = createSelector(logoSelector, userIdSelector, isCompanyOrdersAvailableSelector, (logo, userId, isCompanyOrdersAvailable) => {
  return Boolean(isCompanyOrdersAvailable && (logo === null || logo === void 0 ? void 0 : logo.userId) === userId);
});
const msgTextSelector = createSelector(showDeleteForCompanyFlowSelector, isCompanyOrdersAvailableSelector, (showDeleteForCompanyFlow, isCompanyOrdersAvailable) => {
  return showDeleteForCompanyFlow ? 'Once you delete this artwork you will not be able to recover it, but your team will still be able to see it. Would you like to delete this artwork just for yourself or your whole team?' : `Once you delete this artwork you will not be able to recover it${isCompanyOrdersAvailable ? ', but your team will still be able to see it' : ''}. Are you sure you want to delete it?`;
});
const confirmTextSelector = createSelector(showDeleteForCompanyFlowSelector, showDeleteForCompanyFlow => showDeleteForCompanyFlow ? 'Delete just for Me' : 'Yes, Delete');
const cancelTextSelector = createSelector(showDeleteForCompanyFlowSelector, showDeleteForCompanyFlow => showDeleteForCompanyFlow ? 'Delete for Team' : 'Keep Artwork');
const mapStateToProps = createStructuredSelector({
  open: isConfirmDeleteArtFolderPopupShownSelector,
  logoId: logoIdSelector,
  isCompanyOrdersAvailable: isCompanyOrdersAvailableSelector,
  showDeleteForCompanyFlow: showDeleteForCompanyFlowSelector,
  msgText: msgTextSelector,
  cancelText: cancelTextSelector,
  confirmText: confirmTextSelector
});
const mapDispatchToProps = dispatch => ({
  deleteLogo: params => {
    dispatch(resetLogosPaginationAction());
    dispatch(deleteArtFolderLogo(params));
    dispatch(hidePopup());
  },
  cancelDelete: () => {
    dispatch(hidePopup());
  }
});
export const DeleteArtFolderLogoPopup = connect(mapStateToProps, mapDispatchToProps)(DeleteArtFolderLogoPopupComponent);